export default "__VITE_ASSET__Bo2VPQ2$__"